<template>
<div class="chapter">
<div class="inner_page">
<h2 class="P_Heading_2" id="a__Hlk132641631"><span>Intro</span></h2>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em; text-transform: none;">IT WAS</span> always—<span style=" font-style: italic; font-size: 1.00em;">always</span>—in the name.</p>
<p class="P_Normal">They made no attempt to hide it, and yet, as it always was, their very openness served to deceive. We knew it, of course we did after so many years, but…. But. They gave us back our children. How could we look <span style=" font-style: italic; font-size: 1.00em;">that </span>gift horse in the mouth? Even now I don’t see what else we could have done, but we should have known.</p>
<p class="P_Normal">Because what they took. They changed.</p>
<p class="P_Normal">What they took were children. What they gave back were changelings.</p>
<p class="P_Normal"> </p>
<p class="P_Normal"><span style=" font-style: italic; font-size: 1.00em;">-- The Honorable Andrew Boyd, the American Ambassador-at-Large to the Courts of the Otherworld</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0005.vue?60689521